<ng-template #spinner>
   <mat-spinner diameter="30"></mat-spinner>
</ng-template>

<mat-expansion-panel id="dates" class="bordered" [class.invalid]="(shipment.highlightInvalid$ | async) && !valid()" [formGroup]="shipment.shipmentForm">
   <mat-expansion-panel-header>
      <mat-panel-title id="serviceLevelPanelTitle">Service Level and Dates</mat-panel-title>
   </mat-expansion-panel-header>

   <div class="row">
      <mat-form-field class="servicelevel" *ngIf="enums.servicelevels( shipment.shipType, shipment.mode, true ) | async as servicelevels else spinner">
         <div class="overline">Service Level<ng-container *ngIf="shipment.configs?.servicelevel?.required"> *</ng-container></div>
         <mat-select id="serviceLevelSelect" formControlName="servicelevel" [required]="shipment.configs?.servicelevel?.required">
            <mat-option id="serviceLevelOption" *ngIf="servicelevels.length > 10">
               <ngx-mat-select-search id="serviceLevelSearch" [formControl]="servicelevelFilter" placeholderLabel="Search" noEntriesFoundLabel="Option Not Found"></ngx-mat-select-search>
            </mat-option>
            <mat-option id="serviceLevelOption" *ngFor="let service of filteredServicelevels | async" [value]="service">{{service}}</mat-option>
         </mat-select>
         <mat-error id="serviceLevelError" libInputErrors [control]="shipment.shipmentForm.get('servicelevel')"></mat-error>
      </mat-form-field>

      <ng-container *ngIf="shipment.shipmentForm.get( 'incoterms' )">
         <ng-container *ngIf="enums.incoterms( shipment.mode ) | async as incoterms else spinner">
            <mat-form-field class="incoterms" *ngIf="incoterms.length">
               <div class="overline">Incoterms</div>
               <mat-select id="incotermsSelect" formControlName="incoterms" [required]="shipment.configs?.incoterms?.required">
                  <mat-option id="noneOption">None</mat-option>
                  <mat-option [id]="( term | camelcase ) + 'Option'" *ngFor="let term of incoterms" [value]="term">
                     {{term}}
                  </mat-option>
               </mat-select>
               <mat-error id="incotermsError" libInputErrors [control]="shipment.shipmentForm.get( 'incoterms' )"></mat-error>
            </mat-form-field>
         </ng-container>
      </ng-container>

      <ng-container *ngIf="shipment.shipmentForm.get('awbType')">
         <mat-form-field class="awbType">
            <div class="overline">AWB Type</div>
            <mat-select id="awbTypeSelect" formControlName="awbType" [required]="shipment?.configs?.awbType?.required">
               <mat-option id="noneOption">None</mat-option>
               <mat-option [id]="type + 'Option'" *ngFor="let type of awbTypes" [value]="type">
                  {{type}}
               </mat-option>
            </mat-select>
            <mat-error id="awbTypeError" libInputErrors [control]="shipment.shipmentForm.get('awbType')"></mat-error>
         </mat-form-field>
      </ng-container>
   </div>

   <div class="short-row">
      <div class="date">
         <div class="overline">Pickup Date</div>

         <div class="group">
            <ng-container *ngTemplateOutlet="date; context: { control: shipment.shipmentForm.get('pdatefrom'), key: 'pdatefrom', required: shipment?.configs?.pdatefrom?.required, direction: 'from', min: today }"></ng-container>

            <span>-</span>

            <ng-container *ngTemplateOutlet="date; context: { control: shipment.shipmentForm.get('pdateto'), key: 'pdateto', required: shipment?.configs?.pdateto?.required, direction: 'to', min: shipment.shipmentForm.get( shipment?.configs?.pdateto?.minDate )?.value || today }"></ng-container>
         </div>
      </div>

      <div class="time">
         <div class="overline">Pickup Time</div>

         <div class="group">
            <mat-form-field *ngIf="'ptimefrom' as field">
               <mat-label>From</mat-label>
               <input id="ptimefromInput" #input matInput placeholder="00:00" [required]="shipment?.configs?.ptimefrom?.required" autocomplete="off" [formControlName]="field" (blur)="formatTime( input.value, field )" (click)="breakpoints.large ? '' : openClock(field)" />
               <mat-icon id="ptimefromIcon" matSuffix class="clock" (click)="openClock(field)" zindex="-1">schedule</mat-icon>
               <mat-error id="ptimefromError" libInputErrors [control]="shipment.shipmentForm.get(field)"></mat-error>
            </mat-form-field>

            <span>-</span>

            <mat-form-field *ngIf="'ptimeto' as field">
               <mat-label>To</mat-label>
               <input id="ptimetoInput" #input matInput placeholder="00:00" [required]="shipment?.configs?.ptimeto?.required" autocomplete="off" [formControlName]="field" (blur)="formatTime( input.value, field )" (click)="breakpoints.large ? '' : openClock(field)" />
               <mat-icon id="ptimetoIcon" matSuffix class="clock" (click)="openClock(field)" zindex="-1">schedule</mat-icon>
               <mat-error id="ptimetoError" libInputErrors [control]="shipment.shipmentForm.get(field)"></mat-error>
            </mat-form-field>
         </div>
      </div>

      <div class="date">
         <div class="overline">Delivery Date</div>

         <div class="group">
            <ng-container *ngTemplateOutlet="date; context: { control: shipment.shipmentForm.get('ddatefrom'), key: 'ddatefrom', required: shipment?.configs?.ddatefrom?.required, direction: 'from', min: shipment.shipmentForm.get( shipment?.configs?.ddatefrom?.minDate )?.value || today }"></ng-container>

            <span> - </span>

            <ng-container *ngTemplateOutlet="date; context: { control: shipment.shipmentForm.get('ddateto'), key: 'ddateto', required: shipment?.configs?.ddateto?.required, direction: 'to', min: shipment.shipmentForm.get( shipment?.configs?.ddateto?.minDate )?.value || today }"></ng-container>
         </div>
      </div>

      <div class="time">
         <div class="overline">Delivery Time</div>

         <div class="group">
            <mat-form-field *ngIf="'dtimefrom' as field">
               <mat-label>From</mat-label>
               <input id="dtimefromInput" #input matInput placeholder="00:00" [required]="shipment?.configs?.dtimefrom?.required" autocomplete="off" [formControlName]="field" (blur)="formatTime( input.value, field )" (click)="breakpoints.large ? '' : openClock(field)" />
               <mat-icon id="dtimefromIcon" matSuffix class="clock" (click)="openClock(field)" zindex="-1">schedule</mat-icon>
               <mat-error id="dtimefromError" libInputErrors [control]="shipment.shipmentForm.get(field)"></mat-error>
            </mat-form-field>

            <span>-</span>

            <mat-form-field *ngIf="'dtimeto' as field">
               <mat-label>To</mat-label>
               <input id="dtimetoInput" #input matInput placeholder="00:00" [required]="shipment?.configs?.dtimeto?.required" autocomplete="off" [formControlName]="field" (blur)="formatTime( input.value, field )" (click)="breakpoints.large ? '' : openClock(field)" />
               <mat-icon id="dtimetoIcon" matSuffix class="clock" (click)="openClock(field)" zindex="-1">schedule</mat-icon>
               <mat-error id="dtimetoError" libInputErrors [control]="shipment.shipmentForm.get(field)"></mat-error>
            </mat-form-field>
         </div>
      </div>
   </div>
</mat-expansion-panel>

<ng-template #date let-control="control" let-required="required" let-direction="direction" let-min="min" let-key="key">
   <ng-container *ngIf="!shipment.template">
      <mat-form-field>
         <mat-label>{{direction | titlecase}}</mat-label>
         <input [id]="key + 'Input'" matInput autocomplete="off"
            [required]="required"
            [placeholder]="datePlaceholder"
            [min]="min"
            [matDatepicker]="datepicker"
            [formControl]="control">
         <mat-datepicker-toggle matSuffix [for]="datepicker" tabIndex="-1"></mat-datepicker-toggle>
         <mat-datepicker #datepicker [touchUi]="!breakpoints.large"></mat-datepicker>
         <mat-error id="dtimetoInput"  libInputErrors [control]="control"></mat-error>
      </mat-form-field>
   </ng-container>

   <ng-container *ngIf="shipment.template">
      <mat-form-field>
         <mat-label>{{direction | titlecase}}</mat-label>
         <mat-select [id]="key + 'Select'" [formControl]="control" [required]="required">
            <mat-option id="noneOption">None</mat-option>
            <mat-option [id]="(date | spacers | camelcase ) + 'Option'" *ngFor="let date of startDates" [value]="StartDates[date]">
               {{date | spacers}}
            </mat-option>
         </mat-select>
      </mat-form-field>
   </ng-container>
</ng-template>
